import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";
import React from "react";
import { ResultBookjacket } from "../ResultBookJacket";
import { Link } from "react-router-dom";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { MissingResourceBookJacket } from "../MissingResourceBookJacket";
import { Tooltip, Typography } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";

interface LSResultItemBookjacketWithResource {
  resource: ResourceView | ResourceDWR;
  title?: never;
}

interface LSResultItemBookjacketWithTitle {
  title: string;
  resource?: never;
}

type LSResultItemBookjacketProps =
  | LSResultItemBookjacketWithResource
  | LSResultItemBookjacketWithTitle;

export const LSResultItemBookjacket = ({
  resource,
  title,
}: LSResultItemBookjacketProps) => {
  const { translate } = useLanguage();
  // TODO rename ResultBookjacket to something more generic
  return (
    <>
      {!!resource ? (
        <Tooltip
          title={
            <>
              <Typography variant={"subtitle1"}>
                {resource.shortTitle}
              </Typography>
              {resource.shortAuthor && (
                <Typography variant={"subtitle2"}>
                  {translate("by")} {resource.shortAuthor}
                </Typography>
              )}
            </>
          }
        >
          <Link to={`/resource/${resource.id}`}>
            <ResultBookjacket
              sx={{ margin: "0 auto" }}
              resource={resource}
              width={132}
              height={200}
            />
          </Link>
        </Tooltip>
      ) : (
        <MissingResourceBookJacket title={title} width={132} height={200} />
      )}
    </>
  );
};
